import { render, staticRenderFns } from "./ShipSideView.vue?vue&type=template&id=cfc1cf86"
import script from "./ShipSideView.vue?vue&type=script&lang=ts"
export * from "./ShipSideView.vue?vue&type=script&lang=ts"
import style0 from "./ShipSideView.vue?vue&type=style&index=0&id=cfc1cf86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports